import React, {  useState } from "react";
import Navbar from "../../component/Navbar/Navbar";
import Sidebar from "../../component/sidebar/Sidebar";
import { sidebarSections } from "../Expenses/Expenses";
import expenseItemlogo from "../../Asset/expenseItem.png";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import AddExpenseItem from "./addExpenseItem";
import { useGetExpenseItemsQuery } from "../../redux/features/expenseItem/expenseItemApi";
import { Pagination } from "../../component/Pagination/Pagination";
import { useDebounce } from "use-debounce";

const ExpenseItems = () => {
  const [search, setSearch] = useState("");
  const [page ,setPage] = useState(1)
    const [debouncedSearch] = useDebounce(search, 1500);
 const {data,isLoading,isFetching} = useGetExpenseItemsQuery({search:debouncedSearch,page})

 const expenseItems = data?.data
 const pagination = data?.pagination

  const pageSize = pagination?.pageSize ?? 0;
  const totalExpenseItems = pagination?.totalExpenseItems ?? 0;
  const current = page ?? 1;

  const start = totalExpenseItems > 0 ? (current - 1) * pageSize + 1 : 0;
  let end = current * pageSize;
  if (end > totalExpenseItems) end = totalExpenseItems;



  return (
    <div className="flex flex-col h-screen bg-[#F1F1F1]">
      {/* Navbar */}
      <Navbar page="Cash In" />

      <div className="flex flex-1 overflow-hidden ">
        {/* Sidebar */}
        <div className="md:w-[30%] w-[35%] bg-white shadow-md">
          <Sidebar sidebarSections={sidebarSections} />
        </div>

        {/* Main Content */}
        <div className="flex-1 p-8 relative overflow-y-auto  scrollbar-hide ">
            
         {expenseItems?.length > 0 ? (
             <div className="w-full  mx-auto mb-10 ">
                <div className="flex lg:justify-end justify-start my-4 items-center ">
                  <input
                    type="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="bg-transparent py-2 px-4 border-2 border-[#A9A9A9]  rounded-full outline-none"
                    placeholder="Search by name..."
                  />
                </div>
                {isLoading || isFetching ? (
                   <div className="w-10 h-10 mx-auto border-4 border-[#0D868C]/30 border-t-[#0D868C] rounded-full animate-spin"></div>
                ):(
                     <div className="lg:space-y-4 space-y-2">
                    <div
                    className={`flex items-center justify-between lg:text-[1rem] text-[.8rem]  pb-0 w-full font-bold capitalize`}
                  >
                    <div className="flex items-center  w-[60%]">
                      <span className="w-[20%]">Sr #</span>

                      <span className=" w-[80%]  ">Name</span>
                    </div>

                    <div className="flex items-center justify-end w-[40%]">
                

                      Action
                    </div>
                  </div>
                  {expenseItems?.map((item, index) => {
                    return (
                      <div
                        key={item?._id}
                        className={`flex items-center justify-between lg:pt-4 pt-2 pb-0 border-t-2 border-[#DEDEDE]`}
                      >
                        <div className="flex items-center lg:text-[1rem] text-[.8rem]  w-[60%]">
                          <span className="w-[20%]">{index + 1}</span>

                          <span className="font-inter-600 text-wrap capitalize w-[80%] text-[#0D868C]">
                            {item?.name}
                          </span>
                        </div>

                        <div className="flex items-center justify-end w-[40%] lg:text-[1rem] text-[.8rem]">

                          <div className="flex items-center  md:gap-3 gap-1.5">
                            <AddExpenseItem expenseItem={item} />
                            {/* <span
                              onClick={() =>
                                confirmDelete(cash._id, cash?.description)
                              }
                              className="bg-[#f1524d] text-center text-white p-1 rounded-lg cursor-pointer"
                            >
                              <MdDelete className="lg:size-6 size-5" />
                            </span> */}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {expenseItems?.length !== 0 && (
                <div className="flex items-center justify-between flex-wrap gap-2 w-full p-3 text-[#111111] text-sm font-medium  bg-transparent  border-t-2 border-[#DEDEDE]">
                  <div>
                    Showing <strong className="text-[#111111]">{start}</strong>–
                    <strong className="text-[#111111]">{end}</strong> of{" "}
                    <strong className="text-[#111111]">
                      {pagination?.totalExpenseItems}
                    </strong>
                  </div>
                  <Pagination
                    currentPage={page}
                    totalPages={pagination?.totalPages}
                    changePage={(page) => setPage(page)}
                  />
                </div>
              )}
                </div>
                )}
               
             </div>
         ):(
             <div className="flex items-center justify-center md:w-full w-[27rem]">
              <div className="md:w-[30rem] w-[25rem] lg:w-[38rem]  relative  lg:h-[30rem] h-[23rem] bg-[#A9A9A9] rounded-[2.4rem] text-white flex flex-col justify-center items-center ">
                <img
                  src={expenseItemlogo}
                  className="mb-2 size-16 md:size-32"
                  alt="Logo"
                />

                <p className="text-[1rem] md:text-[1.5rem] font-inter-700 text-center">
                  You have no Expense Item In yet
                </p>
                <p className="text-[.8rem] md:text-[1rem] font-inter-400 text-center">
                  To add a Expense Item, press the (+) button
                </p>
                <AddExpenseItem />
              </div>
            </div>
         )}
          
                <AddExpenseItem />
        
           
        </div>
      </div>
    </div>
  );
};

export default ExpenseItems;
